/* IMPORT */
import { SYMBOL_UNTRACKED, SYMBOL_UNTRACKED_UNWRAPPED } from '../symbols.js';
import { isFunction } from '../utils.js';
/* MAIN */
const isUntracked = (value) => {
    return isFunction(value) && ((SYMBOL_UNTRACKED in value) || (SYMBOL_UNTRACKED_UNWRAPPED in value));
};
/* EXPORT */
export default isUntracked;
